module.exports = __webpack_public_path__ + "img/seven-stars.0b78af53.jpg";